import React, { useState } from "react";
import {Login} from './Login'
export const SuperAdminLogin = () =>{
    return (<Login isAdmin={true} />)
}

